var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1087,
    height: 619,
    viewBox: "0 0 1087 619",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video",
    transform: "translate(-355 -1749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2674",
    "data-name": "Group 2674",
    transform: "translate(355 1749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Screenshot_2021-08-13_at_13.05.14",
    "data-name": "Screenshot 2021-08-13 at 13.05.14",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1087,
    height: 619,
    rx: 61,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1086,
    height: 618,
    rx: 60.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2670",
    "data-name": "Group 2670",
    transform: "translate(259.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Screenshot_2021-08-13_at_13.05.14-2",
    "data-name": "Screenshot 2021-08-13 at 13.05.14",
    width: 1087,
    height: 619,
    rx: 61,
    transform: "translate(-259.5)",
    fill: "rgba(0,0,0,0.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ico_play",
    d: "M58,58.344H16.5A16.5,16.5,0,0,1,0,41.845V16.5A16.5,16.5,0,0,1,16.5,0H58A16.5,16.5,0,0,1,74.5,16.5V41.845A16.5,16.5,0,0,1,58,58.344ZM32.08,16.728a1.729,1.729,0,0,0-1.76,1.79V39.839a1.847,1.847,0,0,0,.871,1.564,1.9,1.9,0,0,0,.87.213,1.623,1.623,0,0,0,.905-.284L50.378,30.671a1.76,1.76,0,0,0,.544-.551,1.842,1.842,0,0,0-.544-2.5L32.967,16.955A1.855,1.855,0,0,0,32.08,16.728Z",
    transform: "translate(246.75 267.11)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.65ca55a3b2b9a5482703921c1b75f379.svg";
export { ForwardRef as ReactComponent };